import * as React from 'react';
import { IInterface, IEquipmentManifest, IInterfaceWashEquipment, ICryptoPayConfig, IWashCardConfig, ICoinlessConfig, INayaxConfig } from '../_types/location';
import { makeStyles } from '@material-ui/core/styles';
import { IWashifyConfig, ITouch4WashConfig, IUnitecConfig, IXpresWashConfig } from '../_types/location';
import WashifyConfig from './interfaceconfig/_washify_config';
import Touch4WashConfig from './interfaceconfig/_touch4wash_config';
import CoinlessConfig from './interfaceconfig/_coinless_config';
import UnitecConfig from './interfaceconfig/_unitec_config';
import CryptoPayConfig from './interfaceconfig/_cryptopay_config';
import WashCardConfig from './interfaceconfig/_washcard_config';
import XpresWashConfig from './interfaceconfig/_xpreswash_config';
import NayaxConfig from './interfaceconfig/_nayax_config';

interface Props {
    classes: any;
    /** the item to display */
    item: IInterfaceWashEquipment;
    manifest: IEquipmentManifest;
    onChange: (iface:IInterfaceWashEquipment) => void;
};

// LEARN
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        }
//     home: { color: "primary" },
//     away: { color: theme.palette.grey[900] }
}));


const InterfaceConfig: React.FC<Props> = (prop: Props) => {

    let classes = useStyles();

    const _onChange = (config: any) => {
        prop.item.remote_config = JSON.stringify(config);
        prop.onChange(prop.item);
    }

    const _renderConfig = () => {
        let inEdit = prop.manifest.interfaces.find(g => g.editing) as IInterface;
        let configStr = prop.item.remote_config;

        switch (inEdit.provider_name) {

            
     
            case "washify": 
    
                let washifyConfig: IWashifyConfig = { CompanyId:"", LocationId: "", ServerId: "", APIKey: "" };
          
                if (configStr) {
                    washifyConfig = JSON.parse(configStr) as IWashifyConfig;
                }
                return (
                    <WashifyConfig classes={classes} item={washifyConfig} onChange={_onChange}/>
                );
            case "touch4wash":
           
                let touch4washconfig: ITouch4WashConfig = { AccountNumber:"", LocationId:"" };
             
                if (configStr) {
                    touch4washconfig = JSON.parse(configStr) as ITouch4WashConfig;
                }
                return (
                    <Touch4WashConfig classes={classes} item={touch4washconfig} onChange={_onChange}/>
                );
            case "unitec":
        
                let unitecconfig: IUnitecConfig = { SiteId: "", DeviceId: "", Password: "", Username: "" };
      
                if (configStr) {
                    unitecconfig = JSON.parse(configStr) as IUnitecConfig;
                }
                return (
                    <UnitecConfig classes={classes} item={unitecconfig} onChange={_onChange}/>
                );
            case "cryptopay":
    
                let cryptopayconfig: ICryptoPayConfig = { SiteId: "", DeviceId: "" };
            
                if (configStr ) {
                    cryptopayconfig = JSON.parse(configStr) as ICryptoPayConfig;
                }
                return (
                    <CryptoPayConfig classes={classes} item={cryptopayconfig} onChange={_onChange}/>
                );
            case "washcard":

                let washcardconfig: IWashCardConfig = { DeviceKey: "" };
            
                if (configStr) {
                    washcardconfig = JSON.parse(configStr) as IWashCardConfig;
                }
                return (
                    <WashCardConfig classes={classes} item={washcardconfig} onChange={_onChange}/>
                );
            case "xpreswash":

                let xpreswashconfig: IXpresWashConfig = { LaneId: "", LocationId: "", SystemId: "", Password: "", Username: "" };
            
                if (configStr) {
                    xpreswashconfig = JSON.parse(configStr) as IXpresWashConfig;
                }
                return (
                    <XpresWashConfig classes={classes} item={xpreswashconfig} onChange={_onChange}/>
                );
            case "coinless":
                let coinlessConfig = { EquipmentId: "" };
                if (configStr) {
                    coinlessConfig = JSON.parse(configStr) as ICoinlessConfig;
                }
                return (
                    <CoinlessConfig classes={classes} item={coinlessConfig} onChange={_onChange}/>
                );
            case "nayax":
                let nayaxConfig: INayaxConfig = { TerminalId: "", UniQR: "" };
                if (configStr) {
                    let parsedNayaxConfig = JSON.parse(configStr);
                    nayaxConfig = { ...nayaxConfig, ...parsedNayaxConfig };
                }
                return (
                    <NayaxConfig classes={classes} item={nayaxConfig} onChange={_onChange}/>
                );
            default: return (<span></span>);
        }
    }

    return _renderConfig();
}


export default InterfaceConfig;
